import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { TwitterShareButton } from 'react-twitter-embed';
import { window, exists } from 'browser-monads';
import FbInit from './FbInit';
import Common from '../../Common';

class Share extends Component {
    constructor(props) {
        super(props);

        this.SPADE = "\u2660"
        this.HEART = "\u2665"
        this.CLOVER = "\u2663"
        this.DIAMOND = "\u2666"

    }

    getCurrentPageUrl = () => {
        let url = ""

        if(exists(window)) {
            let currentUrl = window.location.href;
            url = currentUrl.replace("http://localhost:8000", "https://app.edge.poker")
            url = currentUrl.replace("http://127.0.0.1:8000", "https://app.edge.poker")
        } 

        return url
    }

    changeCardCharToSymbol = (cardText) => {
        let newText = cardText.replace(/s/g, " " + this.SPADE)
        newText = newText.replace(/h/g, " " + this.HEART)
        newText = newText.replace(/c/g, " " + this.CLOVER)
        newText = newText.replace(/d/g, " " + this.DIAMOND)

        return newText
    }

    

    shouldComponentUpdate(nextProps) {
        return (nextProps.shareText !== this.props.shareText)
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            setTimeout(()=> {
                window.FB.XFBML.parse()
            }, 2000)
        } catch {
            console.debug("Cannot run RB.XFBML parse")
        }
    }

    componentDidMount () {
        FbInit.addIfNeeded();
    }

    render() {
        let url = Common.getCurrentPageUrl()

        return (
            <Row className="mb-3 mt-3">
                <Col xs="6">
                    <div id="fb-root"></div>

                    <div key={url}>
                        <div className="fb-share-button float-right" data-href={url} data-layout="button" data-size="large">
                            <a target="_blank" href={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url) 
                                + "&amp;src=sdkpreparse"} 
                                className="fb-xfbml-parse-ignore">
                                Share
                            </a>
                        </div>
                    </div>
                </Col>
                <Col xs="6">
                    <TwitterShareButton
                        key={url}
                        url={url}
                        options={{ text: this.props.shareText, 'size': 'large' }}
                    />
                </Col>
            </Row>
        )
    }

}

export default Share;